import { Alert } from 'shared/ui'
import { type IAlertButtonAction, type IAlert } from 'shared/ui/Alert/types'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { openIntercomNewMessage } from 'entities/Intercom'
import { type ITrigger } from 'entities/Trigger/model/Trigger'

type ITriggerInvalidAlertProps = {
  className?: string
  trigger: ITrigger
  isBottomActions?: boolean
}

export const TriggerInvalidAlert = ({
  className,
  trigger,
  isBottomActions,
}: ITriggerInvalidAlertProps) => {
  if (!trigger.isInvalid) return null

  const info: Partial<IAlert> = {
    title: 'Suspicious content detected',
    desc: 'Your link has been flagged as spam. If you believe this is an error, contact support for assistance.',
  }

  const handleOpenIntercomWidget = () => {
    openIntercomNewMessage()

    modalStore.closeAllModals()
  }

  const action = (): IAlertButtonAction => {
    return {
      variant: 'button',
      type: 'primary',
      text: 'Support',
      onClick: handleOpenIntercomWidget,
    }
  }

  return (
    <div className={className}>
      <Alert
        item={{
          type: 'alert',
          ...info,
        }}
        rightActions={!isBottomActions ? [action()] : undefined}
        actions={isBottomActions ? [action()] : undefined}
      />
    </div>
  )
}
